import { MONTHS } from 'Common/Constants'
import Spinner from 'Common/Spinner'
import PortalMonthDropdown from 'Components/PortalMonthDropdown/PortalMonthDropdown'
import { useMediaQuery } from 'CustomHooks/useMediaQuery'
import React from 'react'
import { LuCircleHelp, LuCreditCard, LuShield } from 'react-icons/lu'
import { Tooltip } from 'react-tooltip'

const PaymentPortalForm = ({ model, handleChange, validationModel, handleChangeMobile, handleActiveForm, authorizePatient, date }) => {
  const isMobile = useMediaQuery('(max-width: 767px)')
  return (
    <>
      <Tooltip id="PaymentPortal_tooltip" place="top" style={{ zIndex: 2, width: isMobile ? 300 : 500, backgroundColor: "black" }} />
      <div className={`min-h-screen paymentWrapper bg-gradient-to-br  from-indigo-50 to-purple-50 flex`}>
        <div className="flex items-center justify-center flex-1 p-4 lg:pl-0">
          <div className="w-full max-w-2xl">
            <div className="bg-white border border-gray-100 shadow-xl rounded-2xl">
              <div className="p-5 sm:p-12">
                {/* Header */}
                <div className="mb-8 text-center">
                  <div className={`inline-flex items-center justify-center w-16 h-16 bg-indigo-500 rounded-full mb-4`}>
                    <LuCreditCard className="w-8 h-8 text-white" />
                  </div>
                  <h1 className="mb-2 text-3xl font-bold text-gray-900">Payment Portal</h1>
                  <p className="leading-relaxed text-gray-600">
                    To securely view your balance, please enter your invoice number and date of birth.
                  </p>
                </div>

                <div className="space-y-6">
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <label htmlFor="invoice" className="block text-sm font-semibold text-gray-700 required"> Invoice Number</label>
                      <LuCircleHelp data-tooltip-id="PaymentPortal_tooltip" data-tooltip-content="You can find your invoice number on the paper statement, email, or text message we sent you." className="w-4 h-4 text-gray-400 transition-colors hover:text-blue-500 cursor-help" />
                    </div>
                    <div className="relative">
                      <input
                        id="invoice"
                        name="invoiceNumber"
                        className={`w-full px-4 py-3 h-10 border-2 rounded-lg focus:ring-1 outline-none focus:ring-indigo-400 focus:border-indigo-400 transition-colors duration-200 border-gray-200 hover:border-gray-300  `}
                        placeholder="Enter your invoice number" value={model.loginModel.invoiceNumber} onChange={handleChange}
                      />
                      {validationModel.invoiceNumberError}
                    </div>
                  </div>
                  <div>
  
                    <div className="flex items-center gap-2 mb-2">
                      <label
                        htmlFor="dob"
                        className="block text-sm font-semibold text-gray-700 required"
                      >
                        Date of Birth
                      </label>
                      <LuCircleHelp
                        data-tooltip-id="PaymentPortal_tooltip"
                        data-tooltip-html="<div><div class='font-semibold mb-2'>Why we ask for your Date of Birth:</div><div>To protect your privacy and comply with HIPAA regulations, we require your Date of Birth to securely verify your identity before granting access to your medical invoice.</div></div>"
                        className="w-4 h-4 text-gray-400 transition-colors hover:text-blue-500 cursor-help"
                      />
                    </div>

                    <div className="flex w-full gap-2 flex-nowrap">

                      {/* Month */}
                      <div className="relative flex-1 min-w-[120px]">
                        <PortalMonthDropdown
                          label="Month"
                          options={MONTHS}
                          value={!date.month ? '' : (MONTHS[Number(date.month) - 1] || '')}
                          onChange={(e) => {
                            const idx = MONTHS.indexOf(e.target.value);
                            const twoDigit = idx >= 0 ? String(idx + 1).padStart(2, '0') : '';
                            handleChangeMobile({ target: { value: twoDigit } }, 'month');
                          }}
                          width="w-full"
                        />
                      </div>
                      
                      {/* Day */}
                      <div className="relative flex-1 min-w-[70px]">
                        <input
                          onChange={(e) => handleChangeMobile(e, 'day')}
                          value={date.day}
                          placeholder=" "
                          className="w-full h-10 px-2 transition-colors duration-200 border-2 border-gray-200 rounded-lg outline-none peer focus:ring-1 focus:ring-indigo-400 focus:border-indigo-400 hover:border-gray-300"
                        />
                        <label className="portalFields">Day</label>
                      </div>

                      {/* Year */}
                      <div className="relative flex-1 min-w-[90px]">
                        <input
                          type="number"
                          inputMode='numeric'
                          value={date.year === '0000' ? '' : date.year}
                          onChange={(e) => handleChangeMobile(e, 'year')}
                          placeholder=" "
                          className="w-full h-10 px-2 transition-colors duration-200 border-2 border-gray-200 rounded-lg outline-none peer focus:ring-1 focus:ring-indigo-400 focus:border-indigo-400 hover:border-gray-300"
                        />
                        <label className="portalFields">Year</label>
                      </div>
                    </div>


                    <span className='text-base text-red-500'>{validationModel.dateOfBirthError}</span>  
                  </div>
                  <button onClick={authorizePatient} className={`w-full bg-gradient-to-r !mt-8 from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 text-white font-semibold py-3 rounded-lg transition-all duration-200 transform hover:scale-[1.02] focus:ring-4 focus:ring-indigo-200 focus:outline-none shadow-lg`} >
                    View Statement{' '}
                    {model.loader && <Spinner size={14} />}
                  </button>

                  <div className='w-full text-center'>
                    <button onClick={() => handleActiveForm("guestPaymentForm")} className="text-sm font-medium text-blue-600 transition-colors hover:text-blue-700 hover:underline">Pay As Guest</button>
                  </div>
                </div>
                {/* Help Section */}
                <div className="pt-6 mt-6 border-t border-gray-100">
                  <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
                    <LuShield className="w-4 h-4" />
                    <span>Your information is secure and HIPAA compliant</span>
                  </div>
                  <div className="mt-3 text-center">
                  </div>
                </div>
                <div className='text-center'>
                  <button data-tooltip-id="PaymentPortal_tooltip" data-tooltip-html="<div><div class=' font-semibold mb-2'>To view and pay securely:</div><div class='mb-2'>1. Enter your Invoice Number provided.</div><div class='mb-3'>2. Enter your Date of Birth to verify your identity.</div><div class='border-t border-gray-400 pt-2'><div class='font-semibold'>Still Need help?</div><div>Call the billing department at the provider's office.</div></div></div>" className="text-sm font-medium text-blue-600 transition-colors hover:text-blue-700 hover:underline">
                    Need help finding your invoice?
                  </button>
                </div>
              </div>
            </div>
            {/* Footer */}
            <div className="mt-6 text-center">
              <p className="text-sm text-gray-500">
                Powered by <a href="https://gettrucare.com" target="_blank" rel="noopener noreferrer" className="font-semibold text-gray-700 hover:underline">Trucare</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>

  )
}

export default PaymentPortalForm